var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "validation-observer",
    { ref: "observer", staticClass: "form", attrs: { tag: "form" } },
    [
      _c(
        "div",
        {
          staticClass:
            "ug-row ug-row--apearance_spaced ug-row--space_md ug-row--align_end-mac"
        },
        [
          _c(
            "div",
            { staticClass: "ug-cell ug-cols ug-cols--12 ug-cols--6-mac" },
            [
              _c("div", { staticClass: "control-cabinet" }, [
                _c("div", { staticClass: "control-cabinet__label" }, [
                  _vm._v("E-mail")
                ]),
                _c(
                  "div",
                  {
                    staticClass:
                      "control-cabinet__element control-cabinet__element--centered"
                  },
                  [_vm._v(_vm._s(_vm.formData.email || "E-mail"))]
                )
              ])
            ]
          ),
          _c(
            "div",
            {
              staticClass:
                "ug-cell ug-cols ug-cols--12 ug-cols--6-md ug-cols--3-mac"
            },
            [
              _c("toggle-mixin-modal", {
                attrs: { "component-name": "EmailChange" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(ref) {
                      var handler = ref.handler
                      return [
                        _c(
                          "button-bemto",
                          {
                            staticClass: "button button--height_xl",
                            on: { event: handler }
                          },
                          [_vm._v("CHANGE EMAIL")]
                        )
                      ]
                    }
                  }
                ])
              })
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass:
                "ug-cell ug-cols ug-cols--12 ug-cols--6-md ug-cols--3-mac"
            },
            [
              _c(
                "button-bemto",
                {
                  staticClass: "button button--height_xl",
                  attrs: { disabled: _vm.isRequest },
                  on: {
                    event: function($event) {
                      return _vm.sendTestEmailAPI()
                    }
                  }
                },
                [
                  _vm.isRequest
                    ? _c("img", {
                        staticClass: "button__load",
                        attrs: { src: "/static/load.gif" }
                      })
                    : _vm._e(),
                  !_vm.isRequest
                    ? _c("div", { staticClass: "button__text" }, [
                        _vm._v("SEND TEST EMAIL")
                      ])
                    : _vm._e()
                ]
              )
            ],
            1
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0a374c80", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0a374c80","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/components/Forms/cabinets/panels/EmailPanel.vue
// module id = 948
// module chunks = 0